import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { FirebaseObjectObservable } from 'angularfire2/database';

import { User } from '../models/user';

import { UserService } from '../services/user.service';

@Injectable()
export class UserResolverService implements Resolve<FirebaseObjectObservable<User | null> | null> {

  constructor(
    private router: Router,
    private userService: UserService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): FirebaseObjectObservable<FirebaseObjectObservable<User | null> | null> {
    const id = route.paramMap.get('user_id');

    if (!id) {
      throw Error('No id specified.');
    }

    return this.userService.getUser(id)
      .take(1)
      .map((user: User | null) => {
        if (user) {
          return this.userService.getUser(user.id);
        } else {
          this.router.navigateByUrl('/');
          return null;
        }
      }) as FirebaseObjectObservable<FirebaseObjectObservable<User | null> | null>;
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/user-resolver.service.ts